import { FC, useState } from 'react';
import { Center, HStack, Spacer, Text, VStack } from '@chakra-ui/react';
import { SendTafMessageOptions } from '@frx/frx-services';
import { getDonationTime, formatDollarAmount } from '../../utils';

import { DonationThanked } from './DonationThanked';
import { DonorSayThanksModal } from './DonorSayThanksModal';
import { DonorSendThankyouModal } from './DonorSendThankyouModal';

export interface DonationProps {
  amount: number;
  contactId: number;
  date: string;
  email?: string;
  giftId: number;
  name: string;
  onThanked?: (
    contactId: number,
    messageOpts?: Pick<
      SendTafMessageOptions,
      'recipients' | 'subject' | 'message_body'
    >
  ) => void;
  thanked: boolean;
}

/**
 *
 * @property amount number
 * @property thanked boolean
 * @property name string
 * @property email string
 * @property giftId number
 * @property date string
 * @property contactId number
 * @property onThanked(contactId: number) callback
 */
export const Donation: FC<Partial<DonationProps>> = (props): JSX.Element => {
  const {
    amount = 0,
    thanked = false,
    name = '',
    date = '',
    email = '',
    contactId = 0,
    onThanked,
  } = props;
  const [showSayThanksModal, setShowSayThanksModal] = useState(false);
  const [showSendThankyouModal, setShowSendThankyouModal] = useState(false);
  const age = `${getDonationTime(date)} ago`;

  return (
    <VStack align="stretch" spacing={3}>
      <HStack>
        <VStack align="stretch" spacing={2}>
          <Text>
            <strong>{name}</strong> donated {formatDollarAmount(amount)}
          </Text>
          <Text color="brand.primary.darkGrey" fontSize="xs">
            {age}
          </Text>
        </VStack>
        <Spacer />
        <DonationThanked
          name={name}
          thanked={thanked}
          onSayThanks={() => {
            setShowSayThanksModal(true);
          }}
        />
      </HStack>
      {!thanked && (
        <>
          <Center>
            <DonorSayThanksModal
              isOpen={showSayThanksModal}
              donorName={name}
              onSendThankyou={() => {
                setShowSendThankyouModal(true);
              }}
              onClosed={() => {
                setShowSayThanksModal(false);
              }}
              onAlreadyThanked={() => {
                setShowSayThanksModal(false);
                if (onThanked) {
                  onThanked(contactId);
                }
              }}
            />
          </Center>
          <Center>
            <DonorSendThankyouModal
              donorName={name}
              isOpen={showSendThankyouModal}
              onClosed={() => {
                setShowSendThankyouModal(false);
                setShowSayThanksModal(false);
              }}
              onCancel={() => {
                setShowSendThankyouModal(false);
                setShowSayThanksModal(false);
              }}
              onSentThankyou={(messageOpts) => {
                setShowSendThankyouModal(false);
                setShowSayThanksModal(false);
                if (onThanked) {
                  onThanked(contactId, {
                    recipients: email,
                    ...messageOpts,
                  });
                }
              }}
            />
          </Center>
        </>
      )}
    </VStack>
  );
};
